import type { InputHTMLAttributes } from "react";

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  id: string;
};

export function TextInput({
  label,
  id,
  className = "",
  ...rest
}: TextInputProps) {
  return (
    <label className="hw-field" htmlFor={id}>
      <span className="hw-field__label">{label}</span>
      <input
        id={id}
        className={`hw-field__input ${className}`.trim()}
        {...rest}
      />
    </label>
  );
}
